import React, { lazy, Suspense } from 'react';

import CardListSkeleton from '@monorepo/common/components/CardListSkeleton';

const OffersByOrder = lazy(() => import('./OffersByOrder'));

export default (props: Config) => (
  <Suspense fallback={<CardListSkeleton />}>
    <OffersByOrder {...props} />
  </Suspense>
);
